<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="'Users'"
      :breadCrumbFirstLink="getFirstLink"
      :breadCrumbSecond="'User Create'"
      :title="'User Create'"
    >
      <div class="form-create__buttons">
        <MainButton buttonWhite @click.native="handleSubmit">Submit</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="form-create">
        <form @submit.prevent="handleSubmit">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :onChange="setName"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :value="formDataToSend.name"
              :placeholder="'Name'"
              :error-messages="validationErrors['name']"
              isBordered
            />
          </div>
          <p class="form-create__label">Email</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'email'"
              :label="'email'"
              :type="'text'"
              :placeholder="'Email'"
              :error-messages="validationErrors['email']"
              isBordered
            />
          </div>
          <p class="form-create__label">Password</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'password'"
              :label="'password'"
              :type="'password'"
              :placeholder="'Password'"
              :error-messages="validationErrors['password']"
              isBordered
            />
          </div>
          <p class="form-create__label">Groups</p>
          <div class="input-container checkbox-container">
            <InputRadio
              :set-value="formDataToSend"
              :id="'group'"
              :values="userGroupsList"
              :name="'name'"
              :value="'id'"
            />
            <Notification :error-messages="validationErrors['group']" />
          </div>
          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>
        <ModalError
          :error-modal="false"
          :handle-close-error-modal="
            () => {
              this.error = {};
            }
          "
        />
      </div>
    </ContentContainer>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import InputRadio from "~/components/atoms/inputs/InputRadio.vue";
import Notification from "~/components/molecules/Notification.vue";

export default {
  name: "UserCreate",
  metaInfo: {
    title: "User Create",
  },
  data() {
    return {
      formDataToSend: {
        name: "",
        email: "",
        password: "",
        group: null,
      },
      groups: [],
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    InputText,
    ModalError,
    InputRadio,
    Notification,
  },
  mounted() {
    this.getGroups();
  },
  computed: {
    ...mapState("users", ["error", "loadingProcess", "validationErrors", "userGroupsList"]),
    getFirstLink() {
      return ROUTE.USERS_LIST.replace(":page", 1);
    },
  },
  methods: {
    getGroups() {
      let url = "";
      this.$store.dispatch("users/getUserGroupsList", url);
    },
    handleSubmit() {
      const data = {
        name: this.formDataToSend.name.length ? this.formDataToSend.name.trim() : "",
        email: this.formDataToSend.email.length ? this.formDataToSend.email : "",
        password: this.formDataToSend.password.length ? this.formDataToSend.password : "",
        group_id: this.formDataToSend.group,
      };
      this.$store.dispatch("users/createUser", data);
    },
    handleBackToList() {
      this.$router.push({
        path: ROUTE.USERS_LIST.replace(":page", 1),
      });
    },
    setName(value) {
      this.formDataToSend.name = value.trim();
    },
  },
};
</script>

<style lang="scss" scoped></style>
